<form [formGroup]="form">
	@for (question of questions; track trackByEstimateQuestionFn($index, question)) {
		@if (question.type == LONG_OPTION_SINGLE_CHOICE) {
			<long-option-single-choice
				[question]="question" [product]="product" [formService]="formService" [form]="form" [disabled]="disabled"></long-option-single-choice>
		}
	}
</form>
